export const filterMixin = {
  props: ['selectedValue', 'list', 'singleMode', 'invalid'],
  computed: {
    displayList() {
      //if we got this filter as object from backend
      if (Array.isArray(this.list[0])) {
        let list = []
        this.list.forEach((item) => {
          list.push({
            id: item[0] + this._uid,
            key: item[0],
            title: item[1],
            pressed: this.selectedValue[item[0]],
          })
        })
        return list
      }
      //if we got this filter as array from backend
      else {
        return this.list.map((item) => {
          return {
            id: item.id + this._uid,
            title: item.name,
            pressed: this.selectedValue.indexOf(item.id) > -1,
            val: item.id,
          }
        })
      }
    },
  },

  methods: {
    //if we got this filter as array from backend
    filterHandlerArray(item) {
      if (this.singleMode) {
        this.$emit('change', [item.val])
        return
      }
      const index = this.selectedValue.indexOf(item.val)
      let currentValues = this.selectedValue
      if (index > -1) currentValues.splice(index, 1)
      else currentValues.push(item.val)

      this.$emit('change', currentValues)
    },
    //if we got this filter as object from backend
    filterHandlerObject({ key, pressed }) {
      let data = {}
      if (!this.singleMode) data = { ...this.selectedValue }
      data[key] = pressed
      this.$emit('change', data)
    },
  },
}
